<template>
  <div>
    <div id="chart" class="histogram-chart-cont">
      <t-loading attach=".histogram-chart-cont" v-if="loading"></t-loading>

      <div class="left">
        <chart-base-histogram
          :options="options"
          :date-keys="dateKeys"
          :unit="unit"
          :legend-data="myLegendData"
          :show-compare-date="showCompareDate"
          ref="chart"
          style="height: 100%"
        ></chart-base-histogram>
      </div>

      <div class="right">
        <div class="legend-cont">
          <div
            class="legend-item"
            v-for="item in myLegendData"
            :key="item.name"
            @click="handleClick(item)"
            :class="{ grey: !item.show }"
          >
            <div class="icon" :style="{ backgroundColor: item.show ? item.color : 'rgb(234, 234, 234)' }"></div>
            <div :title="item.desc" class="name">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import noData from '@/components/common/no-data-card.vue';
import ChartBaseHistogram from '@/components/analysis/chart/base-histogram.vue';

export default {
  components: {
    noData,
    ChartBaseHistogram,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    showCompareDate: {
      type: Boolean,
      default: false,
    },
    unit: {
      type: String,
      default: 'day',
    },
    legendData: {
      type: Array,
      default: () => [],
    },
    dateKeys: {
      type: Object,
    },
    options: {
      type: Object,
    },
    searchWord: {
      type: String,
      required: true,
    },
    topNumber: {
      type: Number,
      default: 10,
    },
  },

  data() {
    return {
      topNOptions: [
        { label: '前10项', value: 10 },
        { label: '前20项', value: 20 },
        { label: '前30项', value: 30 },
        { label: '前40项', value: 40 },
        { label: '前50项', value: 50 },
      ],
      // topN: 10,
      // legendSearchWord: '',
      myLegendData: [],
    };
  },
  watch: {
    legendData: {
      deep: true,
      handler() {
        this.setMyLegendData();
      },
    },
    topNumber() {
      this.setMyLegendData();
    },
    searchWord() {
      this.setMyLegendData();
    },
  },
  mounted() {
    this.setMyLegendData();
  },
  methods: {
    setMyLegendData() {
      const newList = this.legendData.filter(item => item.name.includes(this.searchWord)).slice(0, this.topNumber);
      this.myLegendData = JSON.parse(JSON.stringify(newList));
    },
    handleChangeTopN() {
      this.setMyLegendData();
    },
    handleLegendSearchWordChange() {
      this.setMyLegendData();
    },
    handleClick(item) {
      item.show = !item.show;
    },
  },
};
</script>
<style lang="less" scoped>
.histogram-chart-cont {
  //margin-top: 30px;
  height: 400px;
  display: flex;

  .left {
    flex: 1;
  }

  .right {
    width: 270px;
    padding: 0 0 0 10px;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
  }

  .legend-cont {
    height: 0;
    flex: 1;
    overflow: auto;

    .legend-item {
      display: flex;
      align-items: center;
      line-height: 38px;
      cursor: pointer;
      &:hover {
      }

      &.grey {
        color: #c0ccda;
        .icon {
          background-color: rgb(234, 234, 234);
        }
      }

      .icon {
        width: 20px;
        height: 4px;
        //border: 1px solid red;
        //background-color: rgb(234, 234, 234);
        margin-right: 8px;
      }

      .name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
